<template>
  <div class="head_panel" :style="panelStyle">
    <el-form :inline="true" :model="condition" class="demo-form-inline">
      <el-form-item label="统计类型">
        <el-select v-model="condition.dateType" placeholder="选择统计类型" @change="handleChange">
          <el-option label="月度统计" value="month"></el-option>
          <el-option label="年度统计" value="year"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="年份" v-if="condition.dateType === 'year'">
        <el-date-picker
          v-model="condition.year"
          type="year"
          placeholder="选择年份"
          value-format="yyyy"
          @change="handleChange"
          style="width: 120px;">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="年月" v-if="condition.dateType === 'month'">
        <el-date-picker
          v-model="yearMonth"
          type="month"
          placeholder="选择月份"
          value-format="yyyy-MM"
          @change="handleMonthChange"
          style="width: 160px;">
        </el-date-picker>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default: null
    },
    condition: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      panelStyle: {},
      yearMonth: ''
    }
  },
  mounted() {
    if (this.condition.dateType === 'month' && this.condition.year && this.condition.month) {
      this.yearMonth = `${this.condition.year}-${String(this.condition.month).padStart(2, '0')}`
    }
    this.panelStyle = {
      top: this.config.space + 'px',
      right: this.config.unit + this.config.space * 2 + 'px',
      height: this.config.head.height + 'px',
      width: this.config.width - this.config.unit * 2 - this.config.space * 4 + 'px'
    }
  },
  methods: {
    handleMonthChange(val) {
      if (val) {
        const parts = val.split('-')
        this.condition.year = parseInt(parts[0])
        this.condition.month = parseInt(parts[1])
      }
      this.handleChange()
    },
    handleChange() {
      this.$emit('change', {
        year: this.condition.year,
        month: this.condition.month,
        dateType: this.condition.dateType,
        enterpriseCode: this.condition.enterpriseCode
      })
    }
  }
}
</script>

<style lang="less" scoped>
.head_panel {
  position: absolute;
  border-radius: 10px;
  color: #fff;
  background-color: #282839;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.1), -2px -2px 3px rgba(0, 0, 0, 0.1);
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    .e_name {
      display: none;
      margin-left: 15px;
      cursor: pointer;
    }
    .year {
      margin-left: 15px;
      .el-select {
        width: 95px;
      }
    }
    .enterprise {
      margin-left: 15px;
      .el-select {
        width: 155px;
      }
    }
    .btn-area {
      flex: 1;
      display: flex;
      margin-right: 15px;
      justify-content: right;
      .el-button {
        background-color: #282839;
        border: 1px solid #444;
        color: #fff;
      }
      .el-button:hover {
        background-color: #6e6e9c;
      }
    }
  }
}
</style>
